import { render } from "./WohngeldKZuschlagNew.vue?vue&type=template&id=a1445870"
import script from "./WohngeldKZuschlagNew.vue?vue&type=script&lang=js"
export * from "./WohngeldKZuschlagNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__